import { GetPublicRestockingListQuery } from "shared/queries/publicRestockingList/publicRestockingList.generated";
import { getShelfDetail } from "utils/item";

import { PublicRestockingItem } from "./types";

type PublicRestockingItemFromQuery =
  GetPublicRestockingListQuery["getPublicRestockingList"]["publicRestockingList"]["restockingItems"][0];

export const serializePublicRestockingItem = ({
  sku,
  product,
  priorityTier,
}: PublicRestockingItemFromQuery): PublicRestockingItem => {
  const shelfDetail = product?.inventoryEntry.shelfNumber
    ? getShelfDetail(product.inventoryEntry.shelfNumber)
    : null;
  return {
    sku,
    priorityTier,
    product: product
      ? {
          sku: product.sku,
          name: product.name,
          imageUrl: product.imageUrl ?? null,
          isBio: product.bio ?? null,
          countryOfOriginCode: product.countryOfOrigin.code?.toUpperCase() ?? null,
          shelfLetter: shelfDetail?.shelfLetter ?? null,
          shelfNumber: shelfDetail?.shelfNumber ?? null,
          shelf: product.inventoryEntry.shelfNumber ?? null,
          stockOnShelf: product.inventoryEntry.stock?.shelf ?? 0,
          productClassification: product.productClassification ?? null,
          isShelvedInHandlingUnits: product.isShelvedInHandlingUnits ?? null,
          numberOfShelfFacings: product.numberOfShelfFacings ?? null,
          numberOfShelfStackings: product.numberOfShelfStackings ?? null,
        }
      : null,
  };
};
